// extracted by mini-css-extract-plugin
export default {"wrapper":"activity-icon_wrapper__Z1xVi","icon":"activity-icon_icon__fJZOy"};